import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ImageCropperComponent,
  ImageCroppedEvent,
  LoadedImage,
} from 'ngx-image-cropper';
import { ToastService } from '../../service/toast.service';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';

@Component({
  selector: 'app-image-upload-modal',
  imports: [CommonModule, ImageCropperComponent, LoadingButtonComponent],
  templateUrl: './image-update-modal.component.html',
})
export class ImageUploadModalComponent {
  @Input() loading: boolean = false;
  @Output() imageSelected = new EventEmitter<File>();
  @Output() close = new EventEmitter<void>();
  @Input() cropType: 'square' | 'rectangle' | 'rectangle2' = 'square';

  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl | null = null;
  croppedFile: File | null = null;

  constructor(private sanitizer: DomSanitizer, private toast: ToastService) {}

  fileChangeEvent(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];

    if (!validTypes.includes(file.type)) {
      this.toast.showMessages(
        'warning',
        [],
        'Solo se permiten imágenes JPG/JPEG.'
      );
      input.value = '';
      return;
    }

    if (file.size > 700 * 1024) {
      this.toast.showMessages(
        'warning',
        [],
        'La imagen no debe superar los 700 KB.'
      );
      input.value = '';
      return;
    }
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event.objectUrl) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
        event.objectUrl
      );
    } else {
      this.croppedImage = null;
    }
    this.croppedFile = new File([event.blob!], 'cropped.jpg', {
      type: 'image/jpeg',
    });
  }

  cancel() {
    this.close.emit();
  }

  confirm() {
    if (this.croppedFile) {
      this.imageSelected.emit(this.croppedFile);
    }
  }

  hasImageChanged(): boolean {
    return !!this.imageChangedEvent;
  }
}
